<template>
  <div class="mb-12">
    <h1 class="text-center">Company list</h1>
    <router-link
      class="btn-primary bg-green border-none leading-snug px-4 py-2 text-white my-2 hover:bg-green-900 no-underline rounded-full inline-block"
      to="/create-company"
    >
      Add Company
    </router-link>
    <Table :endpoint="endpoint" :tableConfig="tableConfig" />
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"
import Table from "@/components/DataTable/Table"

export default {
  components: { Table },
  data() {
    return {
      endpoint: `${siteConfig.siteURL}admin/company`,
      tableConfig: [
        {
          header: { textContent: "Name" },
          path: "name",
        },
        {
          header: { textContent: "Id" },
          path: "id",
        },
        {
          header: { textContent: "Created On", sortingParam: "created_on" },
          type: "date",
          path: "created_on",
        },
        {
          header: { textContent: "Updated On", sortingParam: "updated_on" },
          type: "date",
          path: "updated_on",
        },
        {
          header: { textContent: "Archived" },
          path: "is_archived",
        },
        {
          header: { textContent: "Option" },
          path: "id",
          type: "action",
          routePath: "/company-listing/:id",
          actionButtonText: "Edit",
        },
      ],
    }
  },
}
</script>
